import { combineReducers } from 'redux';
import searchResultReducer from './search-result';

const settingsGroupReducer = combineReducers({
  searchResult: searchResultReducer,
});

export default settingsGroupReducer;
